import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const ProtectedRoute = ({ children }) => {
  const accessToken = useSelector((state) => state.auth.accessToken)
  const navigate = useNavigate()

  useEffect(() => {
    if (!accessToken) {
      navigate('/', { replace: true })
    }
  }, [accessToken, navigate])

  return accessToken ? children : null
}

export default ProtectedRoute
